<template>
    <button
        type="button"
        @click="$emit('click')"
        class="btn vBtn"
        :class="{'loading': loading}"
        :disabled="disabled"
    >
        <span>{{text}}</span>
    </button>
</template>

<script>
export default {
    props: ['text', 'loading', 'disabled'],
    data() {
        return {

        };
    }
}
</script>

<style scoped>
.vBtn {
    width: 68px;
    position: relative;
}
.vBtn.loading span {
    visibility: hidden;
    opacity: 0;
}
.vBtn.loading::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 2px solid transparent;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }
    to {
        transform: rotate(1turn);
    }
}

</style>
